import * as Redux from 'redux'
import * as Form from '../../../components/form'
import * as Sortable from '../../../components/sortable'
import * as Elasticsearch from '../../../elasticsearch'
import * as Request from '../../../request'
import * as ReportTypes from '../types'
import * as Constants from './constants'
import * as Utils from './utils'

export const categoriesReducer = (state: string[] = [], action: Request.SuccessAction) => {
  switch (action.type) {
    case Request.successConstant(Constants.CHART):
      return Utils.getCategories(action.payload.response)
    default:
      return state
  }
}
export const percentageReducer = (ratio: Utils.AsPercentArgs) =>
(state: Utils.Percentage[] = [], action: Request.SuccessAction) => {
  switch (action.type) {
    case Request.successConstant(Constants.CHART):
      return Utils.asPercentage(ratio)(action.payload.response)
    default:
      return state
  }
}
export type ChartState = any[]
export const chartReducer = (state: ChartState = [], action: Request.SuccessAction) => {
  switch (action.type) {
    case Request.successConstant(Constants.CHART):
      return action.payload.response
    default:
      return state
  }
}
export interface ViewState {
  isLoading: boolean
}
export const viewReducer = (state = {isLoading: true}, action: Request.SuccessAction) => {
  switch (action.type) {
    case Request.requestConstant(Constants.CHART):
      return {
        ...state,
        isLoading: true,
      }
    case Request.successConstant(Constants.CHART):
    case Request.errorConstant(Constants.CHART):
      return {
        ...state,
        isLoading: false,
      }
    default:
      return state
  }
}
interface FormFields extends ReportTypes.DateRangeFormFields, ReportTypes.CommunityFormFields {
  groupBy: string,
  totalsVsUniques: Constants.DropdownValues,
}
export const initialFieldValues: FormFields = {
  community: null,
  dateRange: Elasticsearch.DateRanges.LastMonth,
  endDate: null,
  groupBy: Elasticsearch.Intervals.Week,
  startDate: null,
  totalsVsUniques: Constants.TotalsVsUniquesMap.UniquePercentage,
}
export type FormState = Form.State<FormFields>
export interface State {
  openRate: Utils.Percentage[],
  clickRate: Utils.Percentage[],
  categories: string[],
  form: FormState,
  view: ViewState,
  sort: Sortable.SimpleState
}
export interface WrappedState {
  analytics: State
}
export const reducer = Redux.combineReducers({
  categories: categoriesReducer,
  clickRate: percentageReducer({
    denominator: Elasticsearch.EmailActionFieldSegments.Delievered,
    numerator: Elasticsearch.EmailActionFieldSegments.Click,
  }),
  form: Form.createReducer(Constants.CHART_FILTER, initialFieldValues),
  openRate: percentageReducer({
    denominator: Elasticsearch.EmailActionFieldSegments.Delievered,
    numerator: Elasticsearch.EmailActionFieldSegments.Open,
  }),
  sort: Sortable.simpleReducer(Constants.CHART),
  view: viewReducer,
})



// WEBPACK FOOTER //
// ./src/pages/reports/analytics/reducer.ts